module.exports = __webpack_public_path__ + "static/5-594a38167646a1efd1545d628477a9bd.jpg";